import { VIEW_TRIP_TRAVELERS } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackViewTravelers = async (context) =>
  trackBaseEvent(context, {
    eventName: VIEW_TRIP_TRAVELERS,
    properties: {},
  });
